module.exports = __webpack_public_path__ + "static/media/lineTags.a10c216c.svg";